import { IEstimateFinanceOptionData } from "common/records/EstimateFinanceOption";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";

export const RECEIVE_ESTIMATE_FINANCE_OPTION = "@estimateFinanceOptions/RECEIVE_ESTIMATE_FINANCE_OPTION";
export const ADD_ESTIMATE_FINANCE_OPTION = "@estimateFinanceOptions/ADD_ESTIMATE_FINANCE_OPTION";
export const REMOVE_ESTIMATE_FINANCE_OPTION = "@estimateFinanceOptions/REMOVE_ESTIMATE_FINANCE_OPTION";
export const CALCULATE_ESTIMATE_FINANCE_OPTION = "@estimateFinanceOptions/CALCULATE_ESTIMATE_FINANCE_OPTION";
export const DUPLICATE_ESTIMATE_FINANCE_OPTION = "@estimateFinanceOptions/DUPLICATE_ESTIMATE_FINANCE_OPTION";

export const EstimateFinanceOptionActions = {
  /**
   * Receives an estimate finance option from the API and stores it in redux
   *
   * @param estimateFinanceOption The estimate finance option data to store
   */
  receiveEstimateFinanceOption: (estimateFinanceOption: Partial<IEstimateFinanceOptionData>) =>
    createAction(RECEIVE_ESTIMATE_FINANCE_OPTION, { estimateFinanceOption }),

  /**
   * Creates a new unsaved estimate finance option linked to an org finance option
   *
   * @param estimateId The id of the estimate to add the finance option to
   * @param financeOptionId The id of the org finance option to link
   */
  addEstimateFinanceOption: (estimateId: number, financeOptionId: number) =>
    createAction(ADD_ESTIMATE_FINANCE_OPTION, { estimateId, financeOptionId }),

  /**
   * Marks an estimate finance option for destruction
   *
   * @param estimateFinanceOptionId The id of the estimate finance option to remove
   */
  removeEstimateFinanceOption: (estimateFinanceOptionId: number) =>
    createAction(REMOVE_ESTIMATE_FINANCE_OPTION, { estimateFinanceOptionId }),

  /**
   * Calculates the monthly payment for an estimate finance option
   * Uses the financed_amount from the estimate's payment_terms
   *
   * @param estimateId The id of the estimate (to get financed_amount)
   * @param estimateFinanceOptionId The id of the estimate finance option to calculate
   */
  calculateEstimateFinanceOption: (estimateId: Nullable<number>, estimateFinanceOptionId: number) =>
    createAction(CALCULATE_ESTIMATE_FINANCE_OPTION, { estimateId, estimateFinanceOptionId }),

  duplicateEstimateFinanceOption: (sourceEstimateFinanceOptionId: number, targetEstimateId: number) =>
    createAction(DUPLICATE_ESTIMATE_FINANCE_OPTION, { sourceEstimateFinanceOptionId, targetEstimateId }),
};

export type EstimateFinanceOptionActions = ActionsUnion<typeof EstimateFinanceOptionActions>;
